<template lang="pug">
    v-layout(row wrap)
        v-flex.pa-2(md12)
            v-tabs#provider-tabs(
                color='grey lighten-4'
                grow
                :height='72'
                slider-color='primary'
            )
                    v-tab(ripple) Detalle
                    v-tab-item(my-3)
                        provider-information
                    v-tab(ripple) Órdenes de compra
                    v-tab-item(my-3)
                        provider-purchase-orders
                    v-tab(ripple) Facturas
                    v-tab-item(my-3)
                        provider-purchase-invoices
                    v-tab(ripple) por pagar
                    v-tab-item(my-3)
                        provider-purchase-invoices-detail-payment
                    v-tab historico de pagos
                    v-tab-item
                       provider-payment-list
</template>

<script>
import ProviderService from '@/services/api/provider'
import {
    ProviderInformation,
    ProviderPchOrders,
    ProviderPurchaseInvoice,
    ProviderPurchaseInvoicesDetailPayment,
} from './tabs'
import ProviderPaymentList from './tabs/ProviderPaymentList'
import { mapActions } from 'vuex'
export default {
    name: 'show-provider',
    props: {},
    data: function() {
        return {
            provider: {},
        }
    },
    computed: {

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        title() {
            return `Proveedor #${this.$route.params.id}`
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    watch: {},
    components: {
        ProviderPaymentList,
        'provider-information': ProviderInformation,
        'provider-purchase-orders': ProviderPchOrders,
        'provider-purchase-invoices': ProviderPurchaseInvoice,
        'provider-purchase-invoices-detail-payment': ProviderPurchaseInvoicesDetailPayment,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: async function() {
        this.setTitleTopBar(this.title)
        const response = await ProviderService.fetchById(this.$route.params.id)
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_PROVIDER'))
                ctx.$router.push('/')
        })
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style>
    #provider-tabs .v-tabs__bar.theme--light.grey.lighten-4 .v-tabs__wrapper {
        border-bottom: 1px solid #1a237e;
    }

    #provider-tabs .v-tabs__slider {
        height: 4px;
    }
</style>
